export function createRoutes() {
  return [
    {
      path: 'comments',
      component: () => import(/* webpackChunkName: "CommentsChrome" */ './CommentChrome.vue'),
      children: [
        {
          path: '/',
          component: () => import(/* webpackChunkName: "CommentList" */ './CommentList.vue'),
        },
        {
          path: 'setting',
          component: () => import(/* webpackChunkName: "CommentInformation" */ './EmailSetting.vue'),
        },
        {
          path: ':commentId',
          component: () => import(/* webpackChunkName: "CommentInformation" */ './CommentInformation.vue'),
        },
      ],
    },
  ];
}
